export default class Sectors {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Sectors;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;


		$(document).on('click', '.js-open-sector-types', function(e) {
			e.preventDefault();
			self.toggleSectorTypes($(this));
		});
	}

	toggleSectorTypes($link) {
		const self = this,
			$sectors = $link.parents('.sectors'),
			$allTypes = $sectors.find('.sector-types'),
			$types = $link.next('.sector-types');

		if ($types.is(':visible')) {
			$types.slideUp();
		} else {
			$allTypes.slideUp();
			$types.slideDown();
		}
	}
}
